// extracted by mini-css-extract-plugin
export default {"mobileModal":"xFH9q0Vq3DpJv1mIJRkC","textNoWrap":"aSVvl5NWbDZKr9z5SZm8"};